import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

import { computed } from 'vue';
import { MeCustomer } from '../Customer';
import AppCodeTextarea from '@/core/components/form/AppCodeTextarea.vue';

interface CustomerFormProps {
	customer: MeCustomer;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerTicketFormInfo',
  props: {
    customer: {}
  },
  setup(__props: any) {

const props = __props;

const ticketFormUrl = computed<string>(() => {
	if (!props.customer.url) {
		return '';
	}

	let urlPrefix = location.origin;
	if (props.customer.whitelabeling) {
		urlPrefix = `${location.protocol}//${props.customer.whitelabeling.domain}`;
	}

	return `${urlPrefix}/t/${props.customer.url}`;
});
const ticketFormEmbedHtml = computed<string>(() => {
	if (!props.customer.url) {
		return '';
	}

	return `<iframe src="${ticketFormUrl.value}"></iframe>`;
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("h3", null, [
      _createTextVNode("Genererad URL")
    ])), [
      [_directive_translate]
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("a", {
        href: ticketFormUrl.value,
        target: "_blank"
      }, _toDisplayString(ticketFormUrl.value), 9, _hoisted_1)
    ]),
    _withDirectives((_openBlock(), _createElementBlock("h3", null, [
      _createTextVNode("Bädda in")
    ])), [
      [_directive_translate]
    ]),
    _createElementVNode("p", null, [
      _createVNode(AppCodeTextarea, { value: ticketFormEmbedHtml.value }, null, 8, ["value"])
    ]),
    (_ctx.customer.whistle_phone)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives((_openBlock(), _createElementBlock("h3", null, [
            _createTextVNode("Telefonnummer för visselblåsare")
          ])), [
            [_directive_translate]
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.customer.whistle_phone), 1)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})